<template>
	<div class="row" :class="depositClass">
		<form class="card shadow-sm" @submit.prevent="performDeposit">
			<div class="card-header pb-0 bd-b-0">
				<h5 class="card-title">{{ headerTitle }}</h5>
				<h6 class="card-subtitle mb-2 text-muted">Please fill out the form.</h6>
			</div>
			<div class="card-body">
				<div class="row">
					<div class="form-group col-12">
						<label>Payment Type</label>
						<select v-model="form.payment_type" class="form-control custom-select shadow-sm" :class="{ 'is-invalid': form.errors.has('payment_type') }" required>
							<option selected :value="null" disabled>Select a payment type</option>
							<option v-for="(type, index) in paymentTypes" :value="type.value" :key="index">{{ type.text }}</option>
						</select>
						<has-error :form="form" field="payment_type"></has-error>
					</div>
					<div class="form-group col-12">
						<label>Amount</label>
						<div class="input-group shadow-sm">
							<div class="input-group-prepend value">
								<span class="input-group-text">{{ form.currency | placeholder('') }}</span>
							</div>
							<input v-model.number="form.amount" type="number" min="0.0" step="any" class="form-control" :class="{ 'is-invalid': form.errors.has('amount') }" placeholder="0.00" required />
						</div>
						<has-error :form="form" field="amount" :class="'d-block'"></has-error>
					</div>

					<ul v-if="form.funding_channel" class="col-lg-12 list-group list-group-flush bd-0">
						<li class="list-group-item d-flex pd-sm-x-20">
							<div class="pd-sm-l-0">
								<p class="tx-medium mg-b-2 tx-color-03">Transaction Charges</p>
								<small class="tx-12 tx-color-03 mg-b-0"></small>
							</div>
							<div class="mg-l-auto text-right">
								<p class="tx-medium mg-b-2 tx-semibold"><span v-if="deposit.charges > 0" class="mx-1">-</span>{{ deposit.charges | toCurrency(form.currency) }}</p>
							</div>
						</li>
						<li class="list-group-item d-flex pd-sm-x-20">
							<div class="pd-sm-l-0">
								<p class="tx-medium mg-b-2 tx-color-03">Total</p>
							</div>
							<div class="mg-l-auto text-right">
								<p class="tx-medium mg-b-2 tx-semibold">{{ deposit.total_units | toCurrency(form.currency) }}</p>
							</div>
						</li>
					</ul>
				</div>

				<div class="d-flex mg-t-15 mg-b-25">
					<button-component :busy="form.busy" :label="'Submit'" :label-loading="'Please wait...'" :button-class="'btn btn-default shadow-sm flex-fill'"></button-component>
					<router-link class="btn btn-primary shadow-sm flex-fill mg-l-10" :to="routeBack" :class="{ disabled: form.busy }">Cancel</router-link>
				</div>
			</div>
		</form>
	</div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
	data() {
		const bank_details = this.$store.getters.getIcGroupBankAccountByType('iclf');
		const { external_client_id } = this.$store.getters.company;

		return {
			bank_details,
			external_client_id,
			routeBack: { name: 'dashboard' },
		};
	},
	watch: {
		'form.payment_type': function (type) {
			if (type) {
				const { channel } = this.paymentTypes.find((paymentType) => paymentType.value === type);

				this.form.funding_channel = channel;
				this.form.payment_service = _.toLower(channel);
			} else {
				this.form.funding_channel = this.form.payment_service = null;
			}

			this.calculateCharges(this.form.amount);
		},
		'form.amount': function () {
			this.calculateCharges(this.form.amount);
		},
	},
	computed: {
		...mapGetters({
			paymentTypes: 'activePaymentTypes',
		}),
	},
	methods: {
		calculateCharges(amount) {
			this.form.units = this.form.amount;
			const charge = _.toLower(this.form.funding_channel) !== 'mtn_mobile_money' ? 0.0195 : 0;
			const charges = parseFloat((Math.ceil(charge * (amount * 100)) + 0) / 100).toFixed(2);

			this.form.charges = this.form.charges = charges;
			this.form.total_units = parseFloat(this.form.amount + 0) - parseFloat(charges);
		},
		performDeposit() {
			this.form.processing_no = this.form.reference = this.generateUuid();
			this.$emit('perform-deposit');
		},
	},
	props: {
		form: {
			type: Object,
			required: true,
		},
		deposit: {
			type: Object,
			required: true,
		},
		headerTitle: {
			type: String,
			required: false,
			default: 'Add Funds',
		},
		depositClass: {
			type: Object | String,
			required: false,
		},
	},
};
</script>

<style>
</style>